import React from 'react';
import componentStyles from './ourPicksSummary.module.css';

const OurPicksSummary = ({ betRecommendation }) => {
    // Extract pick data from bet recommendation
    const moneylinePick = betRecommendation?.moneyLineRecommendedBet || 'N/A';
    const spreadPick = betRecommendation?.spreadRecommendedBet || 'N/A';
    const totalsPick = betRecommendation?.totalsRecommendedBet || 'N/A';
    const hasValidPick = (pick) => {
        const normalizedPick = String(pick || '').trim().toLowerCase();
        return normalizedPick !== '' && normalizedPick !== 'n/a';
    };
    
    // Extract confidence levels
    const moneylineConfidence = betRecommendation?.moneyLineConfidence || 'Medium';
    const spreadConfidence = betRecommendation?.spreadConfidence || 'Medium';
    const totalsConfidence = betRecommendation?.totalsConfidence || 'Medium';

    // Get confidence badge color
    const getConfidenceColor = (confidence) => {
        switch (confidence?.toLowerCase()) {
            case 'high':
                return '#00ff00'; // Green
            case 'medium':
                return '#808000'; // Olive
            case 'low':
                return '#ff0000'; // Red
            default:
                return '#808000'; // Default to olive
        }
    };

    const showConfidenceBadge = (confidence) => {
        const newConfidence = String(confidence || '').toLowerCase();
        return newConfidence === 'high' || newConfidence === 'medium' || newConfidence === 'low';
    };
    // Get confidence badge text
    const getConfidenceText = (confidence) => {
        return confidence?.toUpperCase() || 'MEDIUM';
    };

    const picks = [
        {
            key: 'moneyline',
            label: 'MONEYLINE',
            pick: moneylinePick,
            confidence: moneylineConfidence
        },
        {
            key: 'spread',
            label: 'SPREAD',
            pick: spreadPick,
            confidence: spreadConfidence
        },
        {
            key: 'totals',
            label: 'TOTALS',
            pick: totalsPick,
            confidence: totalsConfidence
        }
    ].filter(({ pick }) => hasValidPick(pick));

    if (picks.length === 0) {
        return null;
    }

    return (
        <div className={componentStyles.ourPicksContainer}>
            <h3 className={componentStyles.ourPicksTitle}>OUR PICKS</h3>
            
            <div className={componentStyles.picksGrid}>
                {picks.map(({ key, label, pick, confidence }) => (
                    <div key={key} className={componentStyles.pickItem}>
                        <div className={componentStyles.pickHeader}>
                            <span className={componentStyles.pickLabel}>{label}</span>
                            {showConfidenceBadge(confidence) && (
                                <span
                                    className={componentStyles.confidenceBadge}
                                    style={{ backgroundColor: getConfidenceColor(confidence) }}
                                >
                                    {getConfidenceText(confidence)}
                                </span>
                            )}
                        </div>
                        <div className={componentStyles.pickValueRow}>
                            <div className={componentStyles.pickValue}>{pick}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OurPicksSummary; 
